export default __webpack_public_path__ + "static/media/art8.d33792c3.jpg";